/**
 * 列表页 session 缓存：刷新/返回时先展示旧数据，后台拉取后再更新，减少白屏与 loading 闪烁。
 */

const memory = new Map()
const PREFIX = 'cp:list:'

export function listCacheKey(name, variant = 'default') {
  return `${PREFIX}${name}:${variant}`
}

export function readListCache(key) {
  if (memory.has(key)) {
    return memory.get(key)
  }
  try {
    const raw = sessionStorage.getItem(key)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    memory.set(key, parsed)
    return parsed
  } catch {
    return null
  }
}

export function writeListCache(key, data) {
  memory.set(key, data)
  try {
    sessionStorage.setItem(key, JSON.stringify(data))
  } catch {
    // sessionStorage 满时仅保留内存
  }
}

export function clearListCache(key) {
  memory.delete(key)
  try {
    sessionStorage.removeItem(key)
  } catch {
    // ignore
  }
}

/** 测评 / 课程：登录态不同接口，缓存分桶 */
export function authListVariant() {
  return localStorage.getItem('jwt_token') ? 'auth' : 'guest'
}
